<template>
  <div class="btn-top">
    <div class="c-buttonForm">
      <div v-on:click="scrolltoForm" class="c-buttonForm-btn">
        <p>Wypełnij formularz</p>
      </div>
    </div>
    <a class="c-buttonForm" href="tel:322698759">
      <div >
        <div  class="c-buttonForm-btn">
          <p>Zapytaj o szczegóły<br />32 269 87 59</p>
        </div>
      </div>
    </a>

  </div>

</template>
<script>
export default {
  name: 'ButtonForm',

  data: function () {
    return {
    }
  },
  methods: {
    scrolltoForm: function () {
      var elmnt = document.getElementById("c-formhtml");
      elmnt.scrollIntoView();
    }
  }
}
</script>
<style lang="scss">
html {
  scroll-behavior: smooth;
}
.btn-top {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1177.6px;
  width: 92%;
  padding-bottom: 3rem;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.c-buttonForm {
  margin: 0 auto;
  max-width: 1177.6px;
  width: 45%;
  padding-top: 3rem;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
  &-btn {
    cursor: pointer;
    background: #c03;
    padding: 5px;
    text-align: center;
    color: #fff;
    font-size: 20px;
    display: flex;
    height: 85px;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    &:hover {
      background: #af022d;
    }
  }
}


</style>
